





































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { uiStore } from '@/store'
import { magistradoApi } from '@/api'
import BusquedaConFiltros from '../BusquedaConFiltros.vue'
import FiltrosMagistrados from './FiltrosMagistrados.vue'
import ListadoMagistrados from './ListadoMagistrados.vue'
import FiltroMagistrados from '@/model/filtros/FiltroMagistrados'
import Magistrado from '@/model/Magistrado'

@Component({
  components: {
    ListadoMagistrados,
    BusquedaConFiltros,
    FiltrosMagistrados,
  },
})
export default class BusquedaMagistrados extends Vue {
  @Prop()
  private filtro: FiltroMagistrados

  @Prop({ type: String, default: 'Búsqueda' })
  private titulo: string

  @Prop({ default: false, type: Boolean })
  private loadingListado = false
  @Prop({ default: false, type: Boolean })
  private disabled

  private loading = false

  private dialog = false

  private test: any = {}

  private id = 0

  private showListado = true

  filtroMagistrados(): Vue & {
    validate: () => boolean
    resetValidation(): void
  } {
    return this.$refs.filtro as Vue & {
      validate: () => boolean
      resetValidation(): void
    }
  }

  createNewInstance(): FiltroMagistrados {
    return new FiltroMagistrados()
  }
  private localVal = (undefined as unknown) as any
  async buscar(val?: any) {
    this.loading = true
    val && val.rowsPerPage
      ? (this.localVal = val)
      : this.localVal
      ? (val = this.localVal)
      : ''
    const page = val && val.page ? val.page : 1

    const size = val && val.rowsPerPage ? val.rowsPerPage : 5

    try {
      if (this.filtroMagistrados().validate()) {
        this.test = await magistradoApi.getMagistrados(
          `?page=${page - 1}&size=${size}${this.filtro.toQuerystring()}`
        )
      }
    } catch (err) {
      uiStore.notification.error(err)
      this.limpiar()
    } finally {
      this.loading = false
    }
  }
  deleteItem(id: number) {
    this.id = id
    this.dialog = true
  }

  editItem(item: Magistrado) {
    this.$emit('edit', item)
  }

  eliminar(id: number) {
    this.$emit('delete', id)
  }

  viewItem(item: Magistrado) {
    this.$emit('view', item)
  }

  limpiar() {
    this.$emit('limpiar-filtro')
    this.test = {}
    this.buscar()
    this.showListado = true
  }
}
